<script setup lang="ts">
import { ref } from "vue";
import { useMouse } from "@vueuse/core";
import { Carousel, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";

const mycarousel = ref();
const showRightArrow = ref(false);
const showLeftArrow = ref(false);

const { x, y } = useMouse();

interface Props {
    images?: Array<string>;
    sitename: string;
}

defineProps<Props>();
</script>

<template>
    <div class="flex w-full">
        <div class="top-gradient absolute top-0 left-0 z-10 h-20 w-full lg:h-60"></div>
        <div @mouseover="showLeftArrow = true" @mouseleave="showLeftArrow = false" class="group absolute left-0 top-0 z-20 h-full w-2/12 cursor-none select-none" @click.prevent="mycarousel.prev()">
            <div
                :style="`left: ${x}px; top: ${y}px;`"
                :class="{ '!h-[6.875rem] !w-[6.875rem] !opacity-100': showLeftArrow }"
                class="pointer-events-none fixed hidden h-10 w-10 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white opacity-0 transition-[opacity,_width,_height] lg:flex"
            >
                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M21 11H6.414l5.293-5.293l-1.414-1.414L2.586 12l7.707 7.707l1.414-1.414L6.414 13H21z" /></svg>
            </div>
        </div>
        <carousel ref="mycarousel" class="flex h-full w-full flex-1" :items-to-show="1" :autoplay="7000" :mouse-drag="false" :wrap-around="true">
            <slide v-for="slide in images" :key="slide">
                <div class="flex h-full flex-1 select-none flex-col">
                    <div class="relative flex-1">
                        <img class="absolute inset-0 h-full w-full object-cover object-[50%_42%]" :src="slide" />
                    </div>
                    <div v-if="sitename !== 'PLUG-IN'" class="h-[6vh] lg:h-[20vh]"></div>
                </div>
            </slide>
        </carousel>
        <div @mouseover="showRightArrow = true" @mouseleave="showRightArrow = false" class="group absolute right-0 top-0 z-20 h-full w-2/12 cursor-none select-none" @click.prevent="mycarousel.next()">
            <div
                :style="`left: ${x}px; top: ${y}px;`"
                :class="{ '!h-[6.875rem] !w-[6.875rem] !opacity-100': showRightArrow }"
                class="pointer-events-none fixed hidden h-10 w-10 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white opacity-0 transition-[opacity,_width,_height] lg:flex"
            >
                <svg width="24" height="24" class="rotate-180" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M21 11H6.414l5.293-5.293l-1.414-1.414L2.586 12l7.707 7.707l1.414-1.414L6.414 13H21z" /></svg>
            </div>
        </div>
        <svg-vue class="absolute bottom-0 left-0 z-10 h-auto w-screen translate-y-[1px]" :class="{ 'scale-[1.15]': sitename === 'PLUG-IN' }" :icon="`hero-visual-${sitename.toLowerCase().replaceAll('-', '')}`"></svg-vue>
    </div>
</template>

<style lang="scss" scoped>
.top-gradient {
    background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.53) 0%, rgba(0, 0, 0, 0.479102) 33.96%, rgba(0, 0, 0, 0) 100%);
}
:deep(.carousel__viewport) {
    flex: 1;
    display: flex;
}

:deep(.carousel__track) {
    flex: 1;
}
</style>
